import { ProjectTypeApiModel } from "@/core/models/api/project-type-api-model.model";
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

export const selectProjectTypeId = (a: ProjectTypeApiModel): number => {
    if(!a.projectTypeId){
        throw new Error("projectTypeId is required");
    }
    return a.projectTypeId; 
}

export interface ProjectTypeState extends EntityState<ProjectTypeApiModel> {
    errorMessage: string | null; 
}

export const projectTypeAdapter: EntityAdapter<ProjectTypeApiModel> = createEntityAdapter<ProjectTypeApiModel>(
    {
        selectId: selectProjectTypeId,
        sortComparer: false
    }
);

export const initialProjectTypeState: ProjectTypeState = 
      projectTypeAdapter.getInitialState({
          errorMessage: null
      });